import { Skeleton } from '@/components/ui/skeleton';

/**
 * The shape of one run group, for the moment before the first results read
 * answers (spec 095 FR-025; spec 079's rule that a placeholder takes the
 * shape of what it stands in for). A heading bar with an outcome chip, then
 * three lines of prose. Shown only after the standard delay, by the caller.
 */
export function ResultsPlaceholder() {
  return (
    <div
      data-testid="results-pending"
      aria-hidden="true"
      className="flex flex-col gap-3"
    >
      <div className="flex items-baseline justify-between gap-3">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-3 w-16" />
      </div>
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-11/12" />
      <Skeleton className="h-3 w-3/4" />
    </div>
  );
}
